export default class RootApi {
    protected ApiRoot: string = `${process.env.REACT_APP_WEB_SERVICE_ENDPOINT}/api`;
}



// WEBPACK FOOTER //
// ./src/api/root-api.ts